/**
 * @generated SignedSource<<1b0c8a7d73e89d2a014e5cc97a69e240>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedSaveSearchContext_user$data = {
  readonly favorites?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __id: string;
        readonly displayName: string | null;
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedSaveSearchContext_user";
};
export type SharedSaveSearchContext_user$key = {
  readonly " $data"?: SharedSaveSearchContext_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedSaveSearchContext_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "favorites"
        ]
      }
    ]
  },
  "name": "SharedSaveSearchContext_user",
  "selections": [
    (v0/*: any*/),
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "favorites",
          "args": null,
          "concreteType": "favoritesConnection",
          "kind": "LinkedField",
          "name": "__SharedSaveSearchContext_favorites_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "favoritesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Favorite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    },
                    {
                      "kind": "ClientExtension",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__id",
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "645e18406e9655421d71a3bd4e9bab5e";

export default node;
